import { useCallback } from 'react'

import { OffersTypesComponents } from '@affiliate-cabinet/types'
import { isEmpty } from '@affstore-ds/helpers'

import { useAdvertisers } from '../useAdvertisers'

export const useAdvertiser = (id?: number | string) => {
  const { data: advertisersData, loading } = useAdvertisers({ withUnknownAdvertiser: true })

  const findAdvertiserById = useCallback(
    (id?: number | string) => {
      const lastAdvertiser = advertisersData[advertisersData.length - 1]

      if (!id) {
        return lastAdvertiser
      }

      return advertisersData.find((advertiserItem) => Number(advertiserItem.value) === Number(id)) || lastAdvertiser
    },
    [advertisersData],
  )

  const findExactAdvertiserById = useCallback(
    (id: number) => advertisersData.find((advertiserItem) => Number(advertiserItem.value) === Number(id)),
    [advertisersData],
  )

  const getAdvertiserListByIds = useCallback(
    (idList: number[] | undefined = []) =>
      idList
        .map((id) => findExactAdvertiserById(id))
        .filter((advertiser) => !isEmpty(advertiser)) as unknown as OffersTypesComponents['schemas']['Advertiser'][],
    [findExactAdvertiserById],
  )

  return {
    advertiser: findAdvertiserById(id),
    findAdvertiserById,
    getAdvertiserListByIds,
    loading,
  }
}
